import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<React.StrictMode data-id="element-227">
      <App data-id="element-228" />
    </React.StrictMode>);
}